// extracted by mini-css-extract-plugin
export default {"cell":"iB5NM","cell__tooltips":"FUqpZ","appear-from-above":"QKpIA","appearFromAbove":"QKpIA"};